import type {FC} from 'react';

import {CallToAction} from '@/modules/foundation/components/call-to-action/CallToAction';
import {CallToActionGroup} from '@/modules/foundation/components/call-to-action-group/CallToActionGroup';

import {linkFragmentToHref} from '../../link/query';

import type {CallToActionLineFragment} from './query';

interface Props {
	value: CallToActionLineFragment;
	className?: string;
	theme?: 'light' | 'dark';
}

export const CallToActionLineContainer: FC<Props> = ({
	value,
	className,
	theme,
}) => {
	return (
		<CallToActionGroup className={className}>
			{value.callToActions?.map((cta) => (
				<CallToAction
					key={cta._key}
					text={cta.text ?? ''}
					variant={
						cta.color === 'secondary' && theme === 'light'
							? 'secondary'
							: cta.color
					}
					targetBlank={cta.targetBlank}
					href={linkFragmentToHref({
						type: cta.type,
						href: cta.href,
						reference: cta.reference,
						targetBlank: cta.targetBlank,
					})}
				/>
			))}
		</CallToActionGroup>
	);
};
